import React, { useState } from "react";
import {
  TextField,
  InputAdornment,
  Typography,
  FormControl,
  FormHelperText,
} from "@mui/material";
import PhoneInput from "react-phone-input-2";
import styled from "@emotion/styled";
import useStyles from "./styles";
import {
  PhoneNumberUtil,
  PhoneNumberFormat,
  PhoneNumberType,
} from "google-libphonenumber";

const phoneUtil = PhoneNumberUtil.getInstance();

const BootstrapInput = styled(TextField)(({ theme }) => ({
  padding: 0,
  width: "100%",
  "& .MuiInputBase-input": {
    border: "none",
    fontSize: 14,
    padding: "8px",
    fontFamily: "Inter Tight",
    outline: "none",
    width: "100%",
    background: "transparent",
  },
}));

const FieldsetWrapper = styled("fieldset")(({ theme, error }) => ({
  borderRadius: "12px",
  padding: "5px 12px",
  border: error ? "1px solid red" : "1px solid rgba(18, 18, 21, 0.10)",
  backgroundColor: "#fff",
  fontFamily: "Inter Tight",
  transition: "border-color 0.3s ease",
  "&:focus-within": {
    borderColor: theme.palette.primary.main,
  },
}));

const Legend = styled("legend")(({ theme, error }) => ({
  fontSize: "13px",
  fontWeight: "500",
  padding: "0 5px",
  color: error ? "red" : "#0D0D0E",
  whiteSpace: "nowrap",
}));

function CPhoneInput({
  label = "",
  required = false,
  error = false,
  helpertext = "",
  placeholder = "Enter phone number",
  state,
  setState,
  isDisabled,
  ...props
}) {
  const classes = useStyles();
  const [phonePlaceholder, setPhonePlaceholder] = useState(placeholder);

  const handlePhoneChange = (code, country) => {
    const countryUpperCase = country?.countryCode.toUpperCase();
    setState({
      ...state,
      pCode: code,
      countryCode: countryUpperCase,
      phone: "",
    });
    
    const exampleNumber = phoneUtil.getExampleNumberForType(
      country?.countryCode,
      PhoneNumberType.MOBILE
    );
    const formattedExampleNumber = phoneUtil.format(
      exampleNumber,
      PhoneNumberFormat.NATIONAL
    );
    setPhonePlaceholder(formattedExampleNumber);
  };

  return (
    <FormControl variant="standard" fullWidth required={required} error={error}>
      <FieldsetWrapper error={error}>
        {label && <Legend error={error}>{label}</Legend>}
        <BootstrapInput
          {...props}
          fullWidth
          placeholder={state.pCode ? phonePlaceholder : placeholder}
          value={state.phone}
          // onChange={(e) => setState({ ...state, phone: e.target.value })}
          InputProps={{
            startAdornment: (
              <InputAdornment
                position="start"
                style={{ marginLeft: "-13px", borderColor: "transparent" }}
                disablePointerEvents={isDisabled}
              >
                <PhoneInput
                  country={"ae"}
                  value={state.pCode}
                  onChange={handlePhoneChange}
                  inputStyle={{
                    width: "50px",
                    marginRight: "5px",
                    marginLeft: "5px",
                    border: "none",
                    outline: "none",
                  }}
                  containerStyle={{ border: "none" }}
                  buttonStyle={{ border: "none" }}
                />
                <Typography
                  className={classes.countryCodeStyle}
                  style={{
                    color: "#0D0D0E",
                    fontSize: "14px",
                    fontWeight: "400",
                    fontFamily: "Inter Tight",
                  }}
                >
                  +{state.pCode}
                </Typography>
              </InputAdornment>
            ),
          }}
          sx={{
            "& .MuiInputBase-root.MuiOutlinedInput-root": {
              borderColor: "transparent", // Remove border color
              boxShadow: "none", // Remove box shadow
            },
            "& .MuiInputBase-root.MuiOutlinedInput-root.Mui-focused": {
              borderColor: "transparent", // Remove border color on focus
              boxShadow: "none", // Remove box shadow on focus
            },
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none", // Remove border from the outline
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: "none", // Remove border on focus
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              border: "none", // Remove border on hover
            },
          }}
        />
      </FieldsetWrapper>
      <FormHelperText error={error}>{helpertext}</FormHelperText>
    </FormControl>
  );
}

export default CPhoneInput;
